import { grey } from '@mui/material/colors';

export default {
  styleOverrides: {  root: {
    backgroundColor: grey[50]
  }
}
};
